import UserList from '@/components/directoryInfo/User/UserList.vue'
import Modal from '@/components/layout/Modal.vue'
import Select2 from '@/components/layout/Select2.vue'
import {mapGetters, mapActions} from 'vuex'
import {SearchUserFromKC} from '@/actions/projectActions.js'
import {CreateUser, GetUserDirectoryUserOne, UpdateUser ,SearchCompanies} from '@/actions/directoryActions.js'
import { IsValidEmail, LinkList,CompanyTypeList , CompanyType} from '@/helpers/utilities.js'
import AutocompleteSelect from '@/components/layout/AutocompleteSelect.vue'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'
import { normalizeDirectoryText, showDirectoryPageWithRecord } from '@/helpers/directoryPagination.js'
export default {
  name: 'User',
  components: {
    UserList,
    Modal,
    Select2,
    AutocompleteSelect
  },
  data(){
    return {
    isUpdateClicked : false,
    invalidEmail : false,
    newUser : {
        companyType : '1',
        roleId : '',
        contacts : [''],
        officeId : ''
    },
    SaveClicked : false,
    addedContacts : [{value : ''}],
    updatedUser : {
        companyType : '1',
        roleId : '',
        contacts : [''],
        officeId : ''
    },
    isUpdateLoading : false,
    updatedContacts : [{value : ''}],
    CompanyTypeList : CompanyTypeList,
    CompanyType : CompanyType,
    addressMaxLength : 255,
    isRecordLocatorLoading : false,
    recordLocatorTitle : 'Updating User Directory',
    recordLocatorMessage : 'Finding the saved user and moving to the right page...',
    highlightedUserId : ''
    }
  },
  mounted : function(){
    this.GetUserList().catch()
    this.GetUserDirectoryInitial().catch()
    this.$store.commit('setActiveLink',LinkList.MAIN_COMPANY)
  },
  methods : {
    ...mapActions(['GetUserList','GetUserDirectoryInitial','UpdateUserRun']),
    SearchCompanies(search){
        return SearchCompanies({search : search})
    },
    UserRecordMatches({ id = '', email = '', name = '' } = {}){
        const normalizedEmail = normalizeDirectoryText(email)
        const normalizedName = normalizeDirectoryText(name)

        return (user) => {
            return (id && user._id === id) ||
                (normalizedEmail && normalizeDirectoryText(user.email) === normalizedEmail) ||
                (normalizedName && normalizeDirectoryText(user.fullname) === normalizedName)
        }
    },
    async ShowUserRecord({ id = '', email = '', name = '', search = '' } = {}){
        const matches = this.UserRecordMatches({ id, email, name })

        const loadMatchingPage = async (searchValue) => {
            const pageData = await showDirectoryPageWithRecord({
                firstPage: await this.GetUserList({search: searchValue, page: 1, focusId: id}),
                loadPage: (page) => this.GetUserList({search: searchValue, page}),
                matches
            })
            const matchedUser = Array.isArray(pageData?.docs)
                ? pageData.docs.find(matches)
                : null

            if(matchedUser){
                this.highlightedUserId = matchedUser._id
                return true
            }

            return false
        }

        this.highlightedUserId = ''

        if(await loadMatchingPage(search || '')){
            return
        }

        if(search){
            await loadMatchingPage('')
        }
    },
    async ShowUserRecordWithLoading({ id = '', email = '', name = '', search = '', successDescription = '' } = {}){
        let showSuccess = false
        this.isRecordLocatorLoading = true

        try {
            await this.ShowUserRecord({ id, email, name, search })
            showSuccess = true
        } finally {
            this.isRecordLocatorLoading = false
        }

        if(showSuccess){
            showDirectorySuccess(this, {
                description: successDescription
            })
        }
    },
    ClearUserHighlight(){
        this.highlightedUserId = ''
    },
    LimitTextField(record, field, maxLength){
        const value = record?.[field]

        if(typeof value === 'string' && value.length > maxLength){
            record[field] = value.slice(0, maxLength)
        }
    },
    updateUser(e){
        const self = this
        const btn = e.target
        self.isUpdateClicked = true
        self.LimitTextField(self.updatedUser, 'address', self.addressMaxLength)
        const { _id ,companyType, companyName, companyAddress, firstName, lastName, roleId, email} = self.updatedUser
        const currentSearch = self.search || ''
        if(!_id ){
            return
        }

        if(companyType==CompanyType.MMOSER){
            if(!companyType || !firstName || !lastName || !roleId  || !IsValidEmail(email) ){
                return
            }
        }
        else if(companyType==CompanyType.CLIENT){
            if(!companyType || !companyName || !companyAddress || !firstName || !lastName  || !IsValidEmail(email) ){
                return
            }
        }else{
            if(!companyType || !companyName || !companyAddress || !firstName || !lastName   || !IsValidEmail(email) ){
                return
            }
        }
        self.isUpdateClicked = false
        btn.disabled = true
        showDirectoryLoading(self, {
            title: 'Updating User',
            description: 'Saving the user changes and updating the directory.'
        })

        self.updatedUser.contacts = self.updatedContacts
            .map((u)=>self.OnlyDigits(u.value))
            .filter((value)=>value!='')

        UpdateUser(self.updatedUser).then((res)=>{
            btn.disabled = false
            closeDirectoryLoading(self)
            if(res=="OK"){
                self.$refs.closeModalUpdate.click()
                self.ShowUserRecordWithLoading({
                    id: _id,
                    email,
                    name: `${firstName || ''} ${lastName || ''}`.trim(),
                    search: currentSearch,
                    successDescription: 'The user details have been updated successfully.'
                }).catch()
            }else{
                showDirectoryError(self, {
                    description: res,
                    duplicateValue: {
                        email,
                        name: `${firstName || ''} ${lastName || ''}`.trim()
                    }
                })
            }
        }).catch((error)=>{
            btn.disabled = false
            closeDirectoryLoading(self)
            showDirectoryError(self, {
                description: error?.message || 'Unable to update user. Please try again.',
                duplicateValue: {
                    email,
                    name: `${firstName || ''} ${lastName || ''}`.trim()
                }
            })
        })
        
    },
    OnCompanyClick(item){
        this.updatedUser.companyName = item.companyName
        this.updatedUser.companyAddress = item.address
    },
    OnCompanyClear(){
        this.updatedUser.companyAddress = ''
    },
    AddNewLineContact(type){
        if(type==1)
            this.addedContacts.push({value : ''})
        else
            this.updatedContacts.push({value : ''})
    },
    OnlyDigits(value){
        return String(value || '').replace(/\D/g, '')
    },
    NormalizeContactNumber(item){
        item.value = this.OnlyDigits(item.value)
    },
    RemoveContact(key, type){
        if(type==1){
            this.addedContacts.splice(key,1)
            this.newUser.contacts.splice(key,1)
        }
        else{
            this.updatedContacts.splice(key,1)
            this.updatedUser.contacts.splice(key,1)
        }
    },
    CheckEmail(value){
      if(value==""){
        return
      }
      this.invalidEmail = !IsValidEmail(value)
    },
    SearchFromKc(search){
        return SearchUserFromKC(search)
    },
    IsValidEmail (value){
        return IsValidEmail(value)
    },
    AppendSelectedKcUser(data){
        this.newUser.firstName = data.firstName
        this.newUser.lastName = data.lastName
        this.newUser.photoUrl = data.photo
        this.newUser.email = data.email
        this.addedContacts = [{value : ''}]
        this.newUser.contacts  = []
        if(data.mobileNo!=""){
            const mobileNo = this.OnlyDigits(data.mobileNo)
            this.addedContacts[0].value = mobileNo
            this.newUser.contacts.push(mobileNo)
        }
    },
    SaveNewUser(e){
      const self = this
      const btn = e.target
      self.SaveClicked = true
      self.LimitTextField(self.newUser, 'address', self.addressMaxLength)
      const { companyType, companyName,companyAddress, firstName, lastName, roleId, email} = self.newUser
      const createdUserEmail = normalizeDirectoryText(email)
      const createdUserName = normalizeDirectoryText(`${firstName || ''} ${lastName || ''}`)

      if(companyType==CompanyType.MMOSER){
          if(!companyType || !firstName || !lastName || !roleId  || !IsValidEmail(email) ){
              return
          }
      }
      else if(companyType==CompanyType.CLIENT){
          if(!companyType || !companyName ||!companyAddress || !firstName || !lastName  || !IsValidEmail(email) ){
              return
          }
      }else{
          if(!companyType || !companyName || !companyAddress || !firstName || !lastName   || !IsValidEmail(email) ){
              return
          }
      }

      btn.disabled = true
      showDirectoryLoading(self, {
        title: 'Creating User',
        description: 'Saving the user and updating the directory.'
      })

      self.newUser.contacts = self.addedContacts
        .map((u)=>self.OnlyDigits(u.value))
        .filter((value)=>value!='')

      CreateUser(self.newUser).then((res)=>{
        btn.disabled = false
        closeDirectoryLoading(self)
        if(res=="OK"){
            self.SaveClicked = false
            self.$refs.closeModalCreate.click()
            self.ShowUserRecordWithLoading({
                email: createdUserEmail,
                name: createdUserName,
                search: '',
                successDescription: 'The user has been created successfully and added to the directory.'
            }).catch()
        }else{
            showDirectoryError(self, {
                description: res,
                duplicateValue: {
                    email,
                    name: `${firstName || ''} ${lastName || ''}`.trim()
                }
            })
        }
      }).catch((error)=>{
        btn.disabled = false
        closeDirectoryLoading(self)
        showDirectoryError(self, {
            description: error?.message || 'Unable to create user. Please try again.',
            duplicateValue: {
                email,
                name: `${firstName || ''} ${lastName || ''}`.trim()
            }
        })
      })
      
    },
    
    OnNewCompanyClick(item){
        this.newUser.companyName = item.companyName
        this.newUser.companyAddress = item.address
    },
    OnNewCompanyClear(){
        this.newUser.companyAddress = ''
    },
    OpenCreateModal(){
        this.SaveClicked = false
        this.newUser =  {
            companyType : '1',
            roleId : '',
            contacts : [''],
            officeId : ''
        }
        this.addedContacts = [{value : ''}]
    },
    OpenUpdateModal(id){
        const self = this
        self.isUpdateClicked = false
        self.updatedUser =  {
            companyType : '1',
            roleId : '',
            contacts : [''],
            officeId : ''
        }

        
        self.updatedContacts = []
        self.isUpdateLoading = true
        GetUserDirectoryUserOne(id).then((res)=>{
            self.updatedUser = res
            self.updatedUser.companyId = res.company?._id
            self.updatedUser.companyName = res.company?.companyName
            self.updatedUser.companyAddress = res.company?.address
            if(!self.updatedUser.contacts){
                self.updatedUser.contacts = []
            }          
            if(self.updatedUser.contacts.length!=0){
                for(let x = 0; x< self.updatedUser.contacts.length; x++){
                    self.updatedContacts.push({value : self.OnlyDigits(self.updatedUser.contacts[x])})
                }
            }else{
                self.updatedContacts = [{value : ''}]
            }

            self.isUpdateLoading = false
            
        })
    }
  },
  computed : mapGetters(['userList','userDataUpdate', 'offices','roles','search','page'])
}
